import React, { useMemo } from 'react';
import { Box, Chip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MarkdownContent from '../../../components/MarkdownContent';
import { parsePrBody } from './prBody';

const PrDescription: React.FC<{ body: string }> = ({ body }) => {
  const blocks = useMemo(() => parsePrBody(body), [body]);

  return (
    <>
      {blocks.map((block, i) => {
        if (block.kind === 'links') {
          return (
            <Box key={i} sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1.5 }}>
              {block.links.map(link => (
                <Chip
                  key={link.href}
                  component="a"
                  href={link.href}
                  target="_blank"
                  rel="noopener"
                  clickable
                  size="small"
                  variant="outlined"
                  icon={<OpenInNewIcon />}
                  label={link.label}
                />
              ))}
            </Box>
          );
        }
        if (block.kind === 'agentBody') {
          // Quoted with a rule rather than indented: this is nearly the whole description, so a
          // real indent would just cost the panel its width. The point is only to show where the
          // agent's text stops and anything a human added begins.
          return (
            <Box key={i} sx={{ borderLeft: 2, borderColor: 'divider', pl: 1.5 }}>
              <MarkdownContent>{block.text}</MarkdownContent>
            </Box>
          );
        }
        return <MarkdownContent key={i}>{block.text}</MarkdownContent>;
      })}
    </>
  );
};

export default PrDescription;
